<template>
  <!-- ID Cell -->
  <component :is="cell" v-bind="$attrs">
    <template v-if="type === 'id'">
      <v-chip
        label
        class="d-flex justify-center text-overline"
        style="font-size: 11px !important; letter-spacing: 1.5px; color: azure"
      >
        {{ item.id }}
      </v-chip>
    </template>

    <!-- Statu Cell -->
    <template v-else-if="type === 'status_txt'">
      <v-alert
        class="ma-0"
        style="padding: 6px 0"
        :color="item.statustype || 'error'"
        text
        :outlined="item.statustype ? true : false"
      >
        <div
          class="text-center text-uppercase text-caption"
          style="font-size: 11px !important; letter-spacing: 1.5px"
        >
          {{ item.status_txt || "BELİRSİZ" }}
        </div>
      </v-alert>
    </template>

    <!-- Bayi Cell -->
    <template v-else-if="type === 'created_by'">
      <v-chip label color="grey" class="d-flex justify-center text-caption">
        <span class="text-caption text-xl-subtitle-2" style="letter-spacing: 0.5px; color: azure">{{
          item.created_by || "BELİRSİZ"
        }}</span>
      </v-chip>
    </template>

    <!-- Tutar Cell -->
    <template v-else-if="type === 'genamount'">
      <div v-if="item.genamount" class="text-caption white--text font-weight-medium">
        {{ item.genamount | currency({ symbol: "" }) }}
      </div>
    </template>

    <!-- Kalem Cell -->
    <template v-else-if="type === 'kalem_sayisi'">
      <v-chip color="#9391a2" outlined class="d-flex justify-center" label>
        <div class="text-capitalize" style="text-align: center; font-size: 11px !important">
          {{ item.expense_lines.length }} Adet
        </div>
      </v-chip>
    </template>

    <!-- İşlem Tarihi Cell -->
    <template v-else-if="type === 'created_date'">
      <v-tooltip color="chip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip color="" class="d-flex justify-center" label v-bind="attrs" v-on="on">
            <div
              class="text-truncate d-flex align-center"
              style="
                width: 140px !important;
                text-align: center;
                font-size: 11px !important;
                letter-spacing: 0.5px;
                color: azure;
              "
            >
              <v-icon color="" small class="mr-2">
                {{ icons.mdiCalendarClock }}
              </v-icon>
              <div class="mr-1">
                {{ item.created_date | moment("DD.MM.YYYY ") }}
              </div>

              <span> - {{ item.created_date | moment("HH:mm") }}</span>
            </div>
          </v-chip>
        </template>
        <div>
          {{ item.created_date | moment("DD MMMM dddd") }}
        </div>
      </v-tooltip>
    </template>

    <!-- Actions Cell -->
    <template v-else-if="type === 'actions'">
      <div class="d-flex justify-space-between align-center">
        <slot name="data-process" :item="item"></slot>
        <slot name="data-edit" :item="item"></slot>
        <slot name="data-view" :item="item"></slot>
      </div>
    </template>
  </component>
</template>

<script>
import { mdiCalendarClock, mdiUpload } from "@mdi/js";

export default {
  name: "TableCells",
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    cell: {
      type: String,
      default: "div",
    },
  },
  data() {
    return {
      icons: {
        mdiCalendarClock,
        mdiUpload,
      },
    };
  },
};
</script>
